import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { streamAI } from "@/lib/ai";

export default function AiTextBlock({ s, field, placeholder, textClass, testId }) {
  const [text, setText] = useState(s[field] || "");
  const [saved, setSaved] = useState(s[field] || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    try { await api.patch(`/sponsors/${s.id}`, { [field]: text }); setSaved(text); toast.success("Texte enregistré"); }
    catch (e) { toast.error(apiError(e)); }
  };

  const generate = async () => {
    setBusy(true);
    setText("");
    try { await streamAI(`/ai/bilan/${s.id}`, { field }, (d) => setText((t) => t + d)); }
    catch (e) { toast.error(e.message); setText(saved); }
    finally { setBusy(false); }
  };

  return (
    <>
      <textarea className="no-print w-full mt-2 bg-white/70 rounded-lg border border-[#C9DDD0] p-3 text-sm min-h-[90px] outline-none focus:border-[#1E6B45]" value={text} onChange={(e) => setText(e.target.value)} placeholder={placeholder} disabled={busy} data-testid={`${testId}-input`} />
      <div className="no-print flex flex-wrap gap-2 mt-2">
        <button type="button" className="btn-outline btn-sm" onClick={generate} disabled={busy} data-testid={`${testId}-ai-button`}>
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />} {busy ? "Rédaction…" : "Rédiger avec l'IA"}
        </button>
        {!busy && text !== saved && <button className="btn-primary btn-sm" onClick={save} data-testid={`${testId}-save`}>Enregistrer le texte</button>}
      </div>
      <p className={`hidden print:block whitespace-pre-line leading-relaxed ${textClass}`}>{text || placeholder}</p>
    </>
  );
}
